import Details from "./school_leave_details.router";
import Entitlement from "./school_leave_entitlement.router";
import Assignment from "./school_leave_assignment.router";
import Application from "./school_leave_application.router";

export default [...Entitlement, ...Details, ...Assignment, ...Application];
